import {
  Drawer,
  IconButton,
  List,
  ListItem,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { MenuOpen } from "@mui/icons-material";
import useMenuStorage, { MainMenuItemCategory } from "../../services/menu/MenuStorageService";
import CoinBalance from "./CoinBalance";
import MenuButton from "./MenuButton";

interface Props {
  menuOpen: boolean;
  setMenuOpen: (menuOpen: boolean) => void;
}
export default observer(function NavbarMenu({ menuOpen, setMenuOpen }:Props) {
  const {menuCategories} = useMenuStorage();
  
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'))

  const toggleMenu = useCallback(() => setMenuOpen(!menuOpen), [menuOpen]);

  return (
    <>
      <IconButton onClick={toggleMenu} sx={{ mx: 3 }}>
        {menuOpen ? <MenuOpen color="primary" /> : <MenuIcon color="primary" />}
      </IconButton>
      <Drawer
        variant={isSmallScreen ? "temporary" : "permanent"}
        sx={{mt: 10, display: {xs: menuOpen ? "block" : "none",sm: "block"}}}
        PaperProps={{ sx: { backgroundColor: "#212121", zIndex: -1 } }}
      >
        <Toolbar />
         <List sx={{ xs: { overflow: "scroll" }, sm: { overflow: "hidden" } }}>
          {menuOpen &&
            <ListItem sx={{display: {xs: "block", sm: "none"}}}>
              <CoinBalance />
            </ListItem>
          }
          {menuCategories.map((item: MainMenuItemCategory) => (
            <MenuButton item={item} menuOpen={menuOpen}/>
          ))}
        </List>
      </Drawer>
    </>
  );
});
